import { Subscription, User } from "../types";

// ID de la membresía requerida para mostrar el CTA "Crear mi comunidad"
// Producción: 5916 | Dev/Staging: 11204
const MEMBERSHIP_ID = parseInt(process.env.REACT_APP_LANZADORES_MEMBERSHIP_ID || "5916");

/**
 * Verifica si el usuario está suscrito a la membresía de Lanzadores
 */
export const isSubscribedToMembership = (
  subscriptions: Subscription[],
): boolean => {
  if (!subscriptions || subscriptions.length === 0) return false;

  const commonsSubscriptionsStates = [
    "active",
    "paid",
    "non_renewing",
    "renewal_retrying",
    "pending_invite",
  ];
  const mpSubscriptionsStates = ["waiting_for_gateway", "not_paid", "retrying"];

  return (
    subscriptions
      ?.filter(
        (subscription) =>
          commonsSubscriptionsStates.includes(subscription.status) ||
          mpSubscriptionsStates.includes(subscription.status)
      )
      .filter((subscription) => subscription.group.id === MEMBERSHIP_ID).length > 0
  );
};

/**
 * Determina si se debe mostrar el CTA "Crear mi comunidad" para un usuario.
 * Sólo se muestra si NO es experto Y tiene una suscripción activa a Lanzadores.
 */
export const shouldShowCreateCommunityCta = (
  userInformation: User,
  subscriptions: Subscription[]
): boolean => {
  const isExpert = !!userInformation?.expert && !!userInformation?.expert?.id;
  if (isExpert) return false;
  return isSubscribedToMembership(subscriptions);
};

/**
 * URL del CTA "Crear mi comunidad". El no-experto va a completar perfil para
 * convertirse en experto; el experto (si por algún motivo llegara) cae en su panel.
 * El Typeform de "lista de espera" no es destino de este botón: solo vive en /expert/signin.
 */
export const getCreateCommunityUrl = (
  userInformation: User,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  subscriptions: Subscription[]
): string => {
  const isExpert = !!userInformation?.expert && !!userInformation?.expert?.id;
  if (isExpert) return "/dashboard/community";
  return "/onboarding/complete-profile";
};

